import { useCallback, useEffect, useRef, useState } from 'react';
import { useOfertasTracker } from '../helpers/use-ofertas-tracker';
import { CarlineWithOfertas, Oferta } from '../services/ofertas-service/models/ofertas';

export const useOfertasSwipeTracking = (carline: CarlineWithOfertas) => {
	const containerRef = useRef<HTMLDivElement>(null);
	const [visibleOfertaIndex, setVisibleOfertaIndex] = useState(0);
	const [hasScrolled, setHasScrolled] = useState(false);
	const { trackOfertasElementSwipe } = useOfertasTracker();

	// Tracking callback
	const getTracking = useCallback(
		(carline: CarlineWithOfertas, oferta: Oferta) => {
			trackOfertasElementSwipe(carline, oferta);
		},
		[trackOfertasElementSwipe],
	);

	// Scroll handler effect
	useEffect(() => {
		const container = containerRef?.current;

		if (!container) return;

		const handleScroll = (e: Event) => {
			const target = e.target as HTMLElement;
			const cardWidth = target.scrollWidth / carline.ofertas.length;
			const scrollLeft = target.scrollLeft;

			const visibleCardIndex = Math.round(scrollLeft / cardWidth);
			setVisibleOfertaIndex(visibleCardIndex);

			setHasScrolled((prevHasScrolled) => prevHasScrolled || visibleCardIndex !== 0);
		};

		container.addEventListener('scroll', handleScroll, { capture: true });

		return () => {
			container.removeEventListener('scroll', handleScroll, { capture: true });
		};
	}, [carline]);

	// Tracking effect
	useEffect(() => {
		if (carline.ofertas.length > 1 && hasScrolled) {
			getTracking(carline, carline.ofertas[visibleOfertaIndex]);
		}
	}, [carline, getTracking, hasScrolled, visibleOfertaIndex]);

	return {
		containerRef,
		visibleOfertaIndex,
		hasScrolled,
	};
};
